<div class="template-success-container">
  <button mat-button (click)="goBack()" class="back-button">
    <mat-icon>arrow_back</mat-icon> Back
  </button>
  <div class="header-container">
    <div class="header-image-container">
      <img class="shiksha-logo" src="../../../../assets/Images/shikshalokam-logo.png" alt="">
    </div>
    <div class="log-out" *ngIf="isUserLogin && !customAuth" (click)="onLogout()">
      <button mat-raised-button>Logout</button>
    </div>
  </div>
  <div class="success-container">
    <mat-card class="template-card">
      <mat-card-content class="template-section">
        <div class="export-container">
          <div>
            <p class="congrats-message">Solution created successfully</p>

            <!-- Single table for both program name and resources -->
            <table class="solution-table">
              <thead>
                <!-- First row: Merged column for Program Name -->
                <tr>
                  <th colspan="2">
                    <h2>Program Name: {{ programName }}</h2>
                  </th>
                </tr>
                <!-- Second row: Resource Name and Solution Link as headers -->
                <tr>
                  <th>Resource Name</th>
                  <th>Solution Link</th>
                </tr>
              </thead>
              <tbody>
                <!-- Rows for resource names and links -->
                <tr *ngFor="let pair of solutionKeyValuePairs">
                  <td>{{ pair.key }}</td>
                  <!-- Apply 'invalid-text' class for red color if invalid -->
                  <td [ngClass]="{'invalid-text': pair.isInvalid}">
                    {{ pair.value }}
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
